export const regex = {
  simpleString: /^[a-zA-Z]+( [a-zA-Z]+)*$/,
  postalCode: /^(F-)?((2[A|B])|[0-9]{2})[0-9]{3}$/,
  phone: /^(?:\+?33\s?|0)(?:\s?\d){8,9}$/g,
  siret: /^\d{14}$/,
  password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.{8,})/g,
  daysBeforeDeletion: /^(?:[0-9]|[1-9][0-9]|[1-2][0-9]{2}|3[0-5][0-9]|36[0-5])$/,
};
